import { render, staticRenderFns } from "./ReferenceCardExpanded.vue?vue&type=template&id=453fa20e&scoped=true&"
import script from "./ReferenceCardExpanded.vue?vue&type=script&lang=js&"
export * from "./ReferenceCardExpanded.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceCardExpanded.vue?vue&type=style&index=0&id=453fa20e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453fa20e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
